import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SettingSidebar from "../components/SettingSidebar";
import SettingUserInfo from "../components/SettingUser";
import { IoCall, IoLockClosed, IoMail } from "react-icons/io5";
import { BASE_URL } from "./Config"; // Import the base URL
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./Setting.css";
export default function Setting() {
  const [activeSection, setActiveSection] = useState(null);
  const [sessionid, setSession] = useState("");
  const [id, setid] = useState(Cookies.get("user_id"));
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");

  const [otpSent, setOtpSent] = useState("");
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  const [veifyloading, setverifyloading] = useState(false);
  const [otploading, setotploading] = useState(false);

  const userid = Cookies.get("user_id");

  const navigate = useNavigate();

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };
  console.log(sessionid);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    if (email !== confirmEmail) {
      toast.warning("Email addresses don't match !");
      return;
    }

    console.log("user data for email update", id, email, password);

    try {
      const response = await axios.post(
        `${BASE_URL}/update_email_by_user_id.php`,
        {
          id,
          email,
          password,
        },
      );

      console.log(response);
      if (response.data.success) {
        toast.success("Email updated successfully !");
        setEmail("");
        setConfirmEmail("");
        setPassword("");

        setTimeout(() => {
          navigate("/setting");
          window.location.reload();
        }, 1500);
      } else {
        toast.warning("Update failed. Try again later ! ");
        // alert("Update failed: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Server error, Try again later !");
    }
  };

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    // console.log("user data for email update", id, currentPassword, newPassword);
    if (newPassword !== confirmPassword) {
      toast.success(" Passwords do not match !");
      return;
    }

    try {
      const userId = localStorage.getItem("userId"); // Or from `sessionid.id`
      const response = await axios.post(
        `${BASE_URL}/update_pass_by_user_id.php`,
        {
          id,
          currentPassword,
          newPassword,
        },
      );

      if (response.data.success) {
        toast.success("Password Updated !");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.success("Update failed ");
      }
    } catch (error) {
      console.error(error);
      toast.success("Server error, Try again later !");
    }
  };

  const [newPhone, setNewPhone] = useState("");
  const [code, setCode] = useState("");
  const [passwordfornumber, setPasswordfornumber] = useState("");

  const handlenumberSubmit = async (e) => {
    e.preventDefault();

    console.log("user data for email update", id, newPhone, passwordfornumber);
    if (newPassword !== confirmPassword) {
      toast.success(" Passwords do not match !");
      return;
    }

    try {
      // Or from `sessionid.id`
      const response = await axios.post(
        `${BASE_URL}/update_number_by_user_id.php`,
        {
          id,
          newPhone,
          passwordfornumber,
        },
      );

      console.log(response);

      if (response.data.success) {
        toast.success("Number Updated !");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.success("Update failed: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.success("Server error, Try again later !");
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!newPhone) {
      toast.warning("Enter valid Phone Number!");
      return;
    }
    if (!passwordfornumber) {
      toast.warning("Password required.");
      return;
    }

    setotploading(true);
    try {
      const res = await axios.post(`${BASE_URL}/send_change_phone_otp.php`, {
        userId: userid,
        newPhone,
        password: passwordfornumber,
      });
      //  console.log("first", res);

      if (res.data.success) {
        toast.success("OTP sent!");
        setOtpSent(true); // show OTP input
        setotploading(false);
      } else {
        toast.warning(res.data.message);
        setotploading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Network Error, Try again later !");
      setotploading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!code) {
      toast.warning("Enter OTP ");
      return;
    }

    setverifyloading(true);

    try {
      const res = await axios.post(`${BASE_URL}/verify_change_phone_otp.php`, {
        userId: userid,
        newPhone,
        otp: code,
      });

      // console.log(res);

      if (res.data.success) {
        toast.success("Phone number updated !");
        setverifyloading(false);
        setOtpSent(false);
        setActiveSection(null);
      } else {
        toast.warning(res.data.message);
        setverifyloading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Network Error, Try again later!");
      setverifyloading(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/Home">
                  <p>HOME</p>
                </Link>
                <span>/</span>
                <p>ACCOUNT DETAILS</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
              <div className="setting-info">
                <SettingUserInfo />
              </div>

              <div className="update-settings">
                <br />
                <h3>
                  <b>Update my details</b>
                </h3>

                <div className="setting-info">
                  <div className="ul update-option">
                    <li onClick={() => toggleSection("email")}>
                      <IoMail
                        className="mail-icon"
                        size={24}
                        color="rgb(66 176 255)"
                      />
                      <b>Change email address</b>
                    </li>
                    <li onClick={() => toggleSection("phone")}>
                      <IoCall
                        className="call-icon"
                        size={24}
                        color="rgb(66 176 255)"
                      />
                      <b>Change phone number</b>
                    </li>
                    <li onClick={() => toggleSection("password")}>
                      <IoLockClosed
                        className="lock-icon"
                        size={24}
                        color="rgb(66 176 255)"
                      />
                      <b> Change password</b>
                    </li>
                  </div>
                </div>
              </div>

              {/* PHONE SECTION */}
              {activeSection === "phone" && (
                <div className="update-settings ">
                  <h1>
                    <b>Change your Phone</b>
                  </h1>
                  <p>We will send you a code to confirm your new phone.</p>

                  <form className="setting-info" onSubmit={handleSendOtp}>
                    <p>New Phone Number</p>
                    <input
                      type="number"
                      className="form-control mt-2"
                      value={newPhone}
                      onChange={(e) => setNewPhone(e.target.value)}
                      placeholder="New phone"
                    />

                    <p className="mt-3">Password</p>
                    <input
                      type="password"
                      className="form-control mt-2"
                      value={passwordfornumber}
                      onChange={(e) => setPasswordfornumber(e.target.value)}
                      placeholder="Password"
                    />

                    {otpSent ? (
                      ""
                    ) : (
                      <button className="Next mt-4" type="submit">
                        {otploading ? "Sending...." : "Send OTP"}
                      </button>
                    )}
                  </form>

                  {otpSent && (
                    <form onSubmit={handleVerifyOtp}>
                      <p>Enter OTP</p>
                      <input
                        type="number"
                        className="form-control mt-2"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Enter OTP"
                      />

                      <button className="Next mt-4" type="submit">
                        {veifyloading ? "Verifying...." : "Verify & Update"}
                      </button>

                      <button
                        className="Next mt-4"
                        type="submit"
                        onClick={handleSendOtp}
                      >
                        {otploading ? "Sending...." : "Resend OTP"}
                      </button>
                    </form>
                  )}
                </div>
              )}

              {/* PASSWORD SECTION */}
              {activeSection === "password" && (
                <div className="update-settings">
                  <h1>
                    <b>Change your Password</b>
                  </h1>
                  <p>Input your current password to complete the operation.</p>

                  <form onSubmit={handlePasswordSubmit}>
                    <div className="setting-info mt-3">
                      <div className="ul update-option">
                        <p>Password</p>
                        <input
                          type="password"
                          placeholder="Current Password"
                          value={currentPassword}
                          onChange={(e) => setCurrentPassword(e.target.value)}
                          className="form-control mt-2"
                        />
                        <br />
                        <p>New Password</p>
                        <input
                          type="password"
                          placeholder="New Password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="form-control mt-2"
                        />
                        <br />
                        <p>Confirm New Password</p>
                        <input
                          type="password"
                          placeholder="Confirm New Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="form-control mt-2"
                        />
                        <br />
                        <input
                          type="submit"
                          value="Update Password"
                          className="Next mt-4"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              )}

              {/* EMAIL SECTION */}
              {activeSection === "email" && (
                <div className="update-settings">
                  <h1>
                    <b>Change your email address</b>
                  </h1>
                  <p>
                    We will send you an email to confirm your new email address.
                  </p>

                  <form onSubmit={handleEmailSubmit}>
                    <div className="setting-info mt-3">
                      <div className="ul update-option">
                        <p>New email address</p>
                        <input
                          type="email"
                          placeholder="New email address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control mt-2"
                        />
                        <br />
                        <p>Confirm new email address</p>
                        <input
                          type="email"
                          placeholder="Confirm new email address"
                          value={confirmEmail}
                          onChange={(e) => setConfirmEmail(e.target.value)}
                          className="form-control mt-2"
                        />
                        <br />
                        <p>Password</p>
                        <input
                          type="password"
                          placeholder="Enter your fast trade password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="form-control mt-2"
                        />
                        <br />
                        <input
                          type="submit"
                          value="Update Email"
                          className="Next mt-4"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
